import styled from 'styled-components'
import Text from '../../../../../../components/text'

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  width: 100%;
  gap: 1.5rem;
  margin-right: 4rem;
`
export const Question = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
  direction: rtl;
  gap: 6rem;
`
export const QuestionSelect = styled.div`
  width: 70%;
`

export const QuestionText = styled(Text)`
  width: 70%;
  word-wrap: break-word;
`
